import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes2";
import useTable from "../../components/useTable";
import { Dimmer } from "../../components/spinner"; // import { formatMoneda } from '../../util/varios';
import moment from "moment";
import { ModalAprobarOrdenCompras } from "./modalAprobarOrdenCompra";
import { Input } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import { AprobarSolicitudesdCompras } from "../comprasyalmacen/modalAprobarSolicitudCompras";

const TablaAprobarOrdenCompra = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° CONTROL.",
      textAlign: "center",
    },
    {
      id: "descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "estado",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtBuscador = useRef();
  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [aprobacion, setAprobacion] = useState();
  const [detalle, setDetalle] = useState();

  let idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              (x.idaprobaciones !== null
                ? x.idaprobaciones.includes(target.value)
                : "") ||
              (x.ordenpagoaprob !== null
                ? x.ordenpagoaprob
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : "") ||
              (x.observaciones !== null
                ? x.observaciones
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : "") ||
              (x.observaciones !== null
                ? x.observaciones
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : "")
            ) {
              return x;
            }
          });
      },
    });
  };
  const seleccionarRegistros = () => {
    let endpoint;
    let ti = 2;
    let depart = 9;
    endpoint =
      op.conexion +
      `/api/administracion/aprobaciones3?dep=${depart}&tip=${ti}&dev=${"1"}&idefiscal=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarAprobacion = (id) => {
    let campos = "*";
    let nomtab = "aprobaciones";
    let nomid = "idaprobaciones";
    let nomid2 = "tipo";
    let id2 = 2;
    let nomid3 = "devuelto";
    let id3 = "1";
    let nomid4 = "efiscal";
    let id4 = idefiscal;

    let endpoint = `${op.conexion}/api/consulta/modeli7?campos=${campos}&nomtab=${nomtab}&id=${id}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}&nomid3=${nomid3}&id3=${id3}&nomid4=${nomid4}&id4=${id4}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setAprobacion(response.data[0]);
          seleccionarDetalle(id);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarDetalle = (id) => {
    let campos = "*";
    let nomtab = "aprobacionesdetalle";
    let condi = "idaprobaciones = " + id;
    let orden = "idaprobacionesdetalle";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          setDetalle(response.data);
          setMostrar2(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const gestionarAprobacion = (op, id) => (e) => {
    e.preventDefault();
    setOperacion(op);
    if (op !== 1) {
      seleccionarAprobacion(id);
    } else {
      setMostrar2(true);
    }
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };
  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5 ">
      <header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant text-light rounded-top">
        <h3 className="m-0">Aprobación de Ordenes de Compras</h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fa fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 p-2 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <Input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
          />
        </div>
        <PrimaryButton
          icon="fas fa-plus m-0"
          onClick={gestionarAprobacion(1, "")}
        ></PrimaryButton>
      </div>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {item.idaprobaciones}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {item.comprasaprob}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {item.observaciones}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {moment.utc(item.fecha).format("DD/MM/YYYY")}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    <button
                      onClick={gestionarAprobacion(4, item.idaprobaciones)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />

      </div>

      <AprobarSolicitudesdCompras
        show={mostrar2}
        operacion={operacion}
        aprobado={aprobacion}
        aprobaciones={aprobacion}
        aprodetalle={detalle}
        titulo={"Compras - Enviar Solicitud de Compras/Servicios"}
        onHideCancelar={() => {
          setMostrar2(false);
        }}
        onHideRenderizar={seleccionarRegistros}
      />

      {/* este modal se cambio por el de aprobacion de compras y alamcen */}
      <ModalAprobarOrdenCompras
        ubi={props.ubi}
        dev={props.dev}
        tip={props.tip}
       // show={mostrar2}
        onHideCancela={() => {
          setMostrar2(false);
        }}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
        aprobacion={aprobacion}
        detalle={detalle}
      />
      {/*   ------------------------------------   */}
      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaAprobarOrdenCompra;
